var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardGrafico',{attrs:{"title":_vm.configuracaoDoGrafico.titulo,"subtitle":_vm.dataDoUltimoProcessamento},scopedSlots:_vm._u([{key:"botoes",fn:function(){return [_c('ButtonDropdown',{attrs:{"label":_vm.$t('plantedArea'),"color":"trv-default","semantic-class":"mini","options":[
					{ label: _vm.$t('plantedArea'), value: 'areaPlantada' },
					{ label: _vm.$t('totalVolumeWithBark'), value: 'volume' },
					{
						label: _vm.$t('aai'),
						value: 'incrementoMedioAnual',
					},
				],"outlined":""},model:{value:(_vm.dropdownTipoGrafico),callback:function ($$v) {_vm.dropdownTipoGrafico=$$v},expression:"dropdownTipoGrafico"}})]},proxy:true},{key:"grafico",fn:function(){return [(_vm.data.length === 0)?_c('Loading'):_c('div',{staticClass:"container__graficofazenda"},[_c('Chart',{ref:"ref__chart",attrs:{"options":_vm.chartOptions}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }